export default function OfflinePage() {
  return (
    <div className="riwis login-page">
      <div className="login-card offline-card" data-testid="offline-message">
        <img className="brand-logo" src="/riwis-logo.png" alt="Riwis Zorg & Welzijn" />
        <p className="eyebrow">Tijdelijk offline</p>
        <h1 className="login-title">Deze site is offline</h1>
        <p className="offline-text">
          Uit veiligheidsoverwegingen hebben we besloten de backup-site offline te halen. Mocht SAM dit weekend weer
          uitvallen kun je contact opnemen met de bereikbaarheid- en beschikbaarheidsdienst. We zullen er dan voor
          zorgen dat de backup-site weer online komt.
        </p>
      </div>
    </div>
  );
}
